import React, { useEffect, useMemo } from 'react'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { Table } from 'components/Ui'
import dayjs from 'dayjs'
injectReducer('translog', reducer)

export default function Translog() {
    const dispatch = useDispatch()
    const { data, tableData, loading } = useSelector(state => state.translog.data)
    const { company, customer } = useSelector(state => state.filterData)
    const { companyData } = useSelector(state => state.listData)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        company,
        customer,
    ])

    const fetchData = () =>
        dispatch(
            getData({
                ...tableData,
                company: company,
                customer: customer,
            })
        )

    const filterData = () => {
        const sort = tableData?.sort || []
        let filtered = data?.filter(item => {
            // if (customer) {
            //     return item?.customer?.toString() === customer
            // }
            return true
        })

        if (sort?.length > 0) {
            sort?.forEach(({ column, dir }) => {
                filtered = filtered?.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }
        return filtered || []
    }

    const columns = useMemo(
        () => [
            {
                field: 'cart',
                header: 'Cart',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'company',
                header: 'Company',
                className: 'min-w-[150px]',
                orderable: true,
                renderCell: row => companyData.find(item => item?.id?.toString() === row?.company?.toString())?.code,
            },
            {
                field: 'message',
                header: 'Message 1',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'message1',
                header: 'Message 2',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'method',
                header: 'Method',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'status',
                header: 'Status',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'start_date_time',
                header: 'Start Date',
                className: 'min-w-[150px]',
                renderCell: row => (row?.start_date_time ? dayjs(row?.start_date_time).format('MMM D, YYYY hh:mm A') : ''),
                orderable: true,
            },
            {
                field: 'end_date_time',
                header: 'End Date',
                className: 'min-w-[150px]',
                renderCell: row => (row?.end_date_time ? dayjs(row?.end_date_time).format('MMM D, YYYY hh:mm A') : ''),
                orderable: true,
            },
        ],
        // eslint-disable-next-line
        [tableData.sort, tableData.query, tableData.pageIndex, tableData.pageSize, tableData.selectedTab, company, customer]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Transaction Log</h2>
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <Table
                    loading={loading}
                    filter={false}
                    datas={filterData()}
                    columns={columns}
                    pagingData={tableData}
                    onChange={e => dispatch(setTableData(e))}
                />
            </div>
        </>
    )
}
